/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React, { useState } from 'react';
import * as S from './styles';
import RenderWhen from '../../When';
import { Row, Col } from 'react-bootstrap';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Image from 'react-bootstrap/Image';
import * as HeroIcon from '@heroicons/react/solid';
import Button from 'react-bootstrap/Button';
import toast from 'react-hot-toast';
import { ExternalLinkIcon } from '@heroicons/react/solid';
import { DocumentDuplicateIcon } from '@heroicons/react/outline';
import { FiEyeOff, FiEye } from 'react-icons/fi';
import Popover from 'react-bootstrap/Popover';
import ListGroup from 'react-bootstrap/ListGroup';
import { Form, InputGroup } from 'react-bootstrap';
import { StatusComp, IStatusCompProps } from '../StatusComp';
import { ProtectedImage } from '@/widgets/item-spec-venus-widget-react/components/MediaCarousel/components/ProtectedImage';
const MAX_LENGTH = 77;

export interface IProfileProps {
  text?: string;
  profileImage?: string;
  name?: string;
  meta?: string | string[];
  metaSymbol?: string;
  isNoProfileExist?: boolean;
  navBar?: {
    key?: string;
    navItem?: string;
  }[];
  symbol?: string;
  groupIcons?: {
    id: string;
    type?: string;
    icon: string;
    tooltip: string;
  }[];
  listItems?: {
    key: string;
    title: string;
    subTitle: string;
    icon: string;
    // flag?: string;
    // verified?: boolean;
    masked?: boolean;
  }[];
  badge?: string;
  badge_color?: string;
  badge_background?: string;
  badgeColor?: string;
  badgeBg?: string;
  checkBoxText?: string;
  submitBtnText?: string;
  downloadButtonText?: string;
  verifyBtnText?: string;
  onDownload?(): void;
  onSubmit?(): void;
  onVerify?(): void;
  terminateText?: string;
  onTerminate?(): void;
  statusProps?: IStatusCompProps;
  iscomment?: any;
  showcomment?: any;
  closecomment?(): any;
  setShowComment?: any;
  status?: any;
  legacy?: any;
}
const getFirstLetterOfEachWord = (text: any) =>
  text?.match(/\b\w/g)?.join('')?.substr(0, 2)?.toUpperCase();

export const ProfileComp = ({
  text,
  profileImage,
  name,
  meta,
  symbol,
  groupIcons,
  metaSymbol,
  verifyBtnText,
  badge,
  listItems,
  badgeColor,
  badgeBg,
  checkBoxText,
  submitBtnText,
  downloadButtonText,
  onDownload,
  onSubmit,
  onTerminate,
  terminateText,
  statusProps,
  iscomment,
  onVerify,
  showcomment,
  closecomment,
  setShowComment,
  status,
  legacy
}: IProfileProps) => {
  console.log('profilecompprops', listItems);
  const [isMasked, setIsMasked] = useState<boolean>(false);
  const [checked, setChecked] = useState<boolean>(false);
  const [color, setColor] = useState<string>('red');

  const _getIcon = () => {
    // if (profileImage) {
    //   return <S.profile src={profileImage} className="rounded-circle" alt="Avatar" />;
    // }
    return (
      <div
        style={{
          display: 'flex',
          paddingTop: '3%',
          height: '100%',
          justifyContent: 'center',
          // alignItems:"center"
        }}
      >
        <ProtectedImage src={profileImage} style={{height:'5rem',width:'4rem'}} alt="Avatar" className="rounded"/>
        {/* <S.profile src={profileImage} alt="Avatar" className="rounded" /> */}
      </div>
    );
    // else
    //   return (
    //     <S.profileTag className="rounded-circle d-flex align-items-center justify-content-center fw-bold  bg-secondary">
    //       <h3 className="p-5">{getFirstLetterOfEachWord(name)}</h3>
    //     </S.profileTag>
    //   );
  };

  const isValidUrl = (urlString: string) => {
    try {
      return Boolean(new URL(urlString));
    } catch (e) {
      return false;
    }
  };

  const _getMeta = (title?: string | string[]) => {
    if (Array.isArray(title) && title?.length > 0) {
      return (
        <>
          {title?.map((ele, index) => {
            if (index === 0) {
              return <span key={`${ele}-${index}`}>{ele}</span>;
            }
            return (
              <span className="m-2" key={`${ele}-${index}`}>
                {metaSymbol} {ele}
              </span>
            );
          })}
        </>
      );
    } else return title;
  };

  const _getIcons = (Icon: any) => {
    let _icon: any = [];
    if (typeof Icon === 'string') {
      if (isValidUrl(Icon)) {
        _icon.push(
          <Image
            key={`image-icon`}
            src={Icon}
            width={60}
            height={60}
            className="icon icon-xs"
          />
        );
      } else {
        const _icons: any = HeroIcon;
        const NavIcon = _icons[Icon];
        if (NavIcon) {
          _icon.push(
            <NavIcon key={`hero-icon`} src={Icon} className="icon icon-xs" />
          );
        }
      }
      return _icon;
    }
    if (Icon) {
      _icon.push(<Icon key={`hero-icon-2`} className="icon icon-xs" />);
    }
    return _icon;
  };

  const _renderIcons = (icons?: any[]) => {
    const _comp: any = [];
    if (icons && icons.length > 0) {
      icons.forEach((item, index) => {
        if (item?.type === 'icon') {
          _comp.push(
            <OverlayTrigger
              overlay={(props) => (
                <Tooltip {...props}>{item.tooltip ?? ''}</Tooltip>
              )}
              placement={'bottom'}
              key={`overlay-${index}`}
            >
              <S.Icon
                key={`group-card-${item?.id}-${index}`}
                // onClick={() => {
                //   onGroupIconClick && onGroupIconClick(item.id);
                // }}
              >
                {_getIcons(item.icon)}
              </S.Icon>
            </OverlayTrigger>
          );
        } else if (item?.type === 'button') {
          _comp.push(
            <S.ButtonContainer>
              <Button
                // onClick={onButtonClick.bind(null, item)}
                variant="primary"
                className="m-0 py-1"
              >
                {item?.tooltip}
              </Button>
            </S.ButtonContainer>
          );
        }
      });
    }
    return _comp;
  };

  const onToggle = () => {
    setIsMasked(!isMasked);
  };

  function start_and_end(str: any) {
    if (str?.length > 25) {
      return (
        str?.substr(0, 10) +
        '.....' +
        str?.substr(str?.length - 10, str?.length)
      );
    }
    return str;
  }

  const _renderMaskIconIf = (item: any) => {
    if (item?.masked) {
      if (!isMasked)
        return (
          <span onClick={onToggle} className="px-2">
            <FiEye size={15} />
          </span>
        );

      if (isMasked) {
        return (
          <span onClick={onToggle} className="px-2">
            <FiEyeOff size={15} />
          </span>
        );
      }
    }
    return null;
  };

  function isValidHttpUrl(string: any) {
    let url;
    try {
      url = new URL(string);
    } catch (_) {
      return false;
    }
    return url.protocol === 'http:' || url.protocol === 'https:';
  }

  const mask = (cc: any, num = 4, mask = '*') =>
    `${cc}`.slice(-num).padStart(`${cc}`.length, mask);

  const _renderSubTitle = (item: any) => {
    console.log('render subtitle', item);

    const popover = (
      <Popover id="popover-basic">
        <Popover.Body>{item?.subTitle}</Popover.Body>
      </Popover>
    );

    const k = 'pp';
    k.length;

    const popover1 = (
      <Popover id="popover-basic">
        <Popover.Body>{'Copy to clipboard'}</Popover.Body>
      </Popover>
    );

    if (item?.subTitle && item?.subTitle?.length > 25) {
      if (isValidHttpUrl(item?.subTitle)) {
        return (
          <>
            <OverlayTrigger trigger="hover" placement="top" overlay={popover}>
              <span>{start_and_end(item?.subTitle)}</span>
            </OverlayTrigger>
            {/* <OverlayTrigger trigger="hover" placement="top" overlay={popover1}>
              <DocumentDuplicateIcon
                onClick={() => {
                  toast.success('copied!');
                  navigator.clipboard.writeText(item?.subTitle);
                }}
                className="icon icon-xs ms-2"
                color="#858585"
                style={{ cursor: 'pointer' }}
              />
            </OverlayTrigger> */}
            <a href={item?.subTitle} target="_blank">
              <ExternalLinkIcon className="icon icon-xs ms-2" color="#858585" />
            </a>
          </>
        );
      } else {
        return (
          <>
            <OverlayTrigger trigger="hover" placement="top" overlay={popover}>
              <span>{start_and_end(item?.subTitle)}</span>
            </OverlayTrigger>
            {/* <OverlayTrigger trigger="hover" placement="top" overlay={popover1}>
              <DocumentDuplicateIcon
                color="#858585"
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  toast.success('copied!');
                  navigator.clipboard.writeText(item?.subTitle);
                }}
                className="icon icon-xs ms-2"
              />
            </OverlayTrigger> */}
          </>
        );
      }
    }
    if (item?.masked) {
      if (!isMasked) {
        return mask(item?.subTitle, 3);
      }
      if (isMasked) {
        return start_and_end(item?.subTitle);
      }
    } else return start_and_end(item?.subTitle);
  };

  const _renderList = () => {
    return (
      <>
        {listItems?.map((item, index) => {
          return (
            <S.ListCol xs={12} md={4} key={`${item?.key}-${index}`}>
              <ListGroup>
                <S.ListIconContainer>
                  <S.IconImage src={item?.icon} />
                  <div className="px-3">
                    <S.ListTitle className="fs-8 mb-0 pb-0 mt-0">
                      {item?.title}
                    </S.ListTitle>
                    <S.SubTitle className="fs-8 mb-0 w-100 ">
                      {_renderSubTitle(item)}
                      {_renderMaskIconIf(item)}
                    </S.SubTitle>
                  </div>
                </S.ListIconContainer>
              </ListGroup>
            </S.ListCol>
          );
        })}
      </>
    );
  };

  console.log('profileImage :::: ->', statusProps);
  console.log('item->', checked);

  return (
    <div style={{ display: 'flex', justifyContent: 'center' }}>
      <S.SRow
        className="d-flex justify-content-center align-item-center mb-4"
        style={{
          padding: '3%',
          width: '95%',
          boxShadow:
            '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)',
        }}
      >
        <Row>
          {profileImage && (
            <Col
              style={{ border: '!px solid black' }}
              lg={2}
              md={3}
              sm={4}
              xs={4}
            >
              {_getIcon()}
            </Col>
          )}
          <S.SCol className="w-80 mx-2">
            {profileImage ? (
              <div className="mt-3">
                {name && (
                  <>
                    {/* <div style={{border:"1px solid red"}}> */}
                    <S.Name>{name} </S.Name>
                    {/* </div> */}
                    {/* <div style={{border:"1px solid red"}}> */}
                    {badge && (
                      <S.BadgeStyle badgeColor={badgeColor} badgeBg={badgeBg}>
                        {badge}
                      </S.BadgeStyle>
                    )}
                       {legacy && (
                      <S.BadgeStyle badgeColor={badgeColor} badgeBg={"#f0aa117d"}>
                       {legacy}
                      </S.BadgeStyle>
                    )}
                    {/* </div> */}
                    <RenderWhen.If isTrue={!!meta}>
                      <S.Meta className="m-0 p-0">{_getMeta(meta)}</S.Meta>
                    </RenderWhen.If>
                  </>
                )}
              </div>
            ) : (
              <div className="mt-3">
                {name && (
                  <>
                    {/* <div style={{border:"1px solid red"}}> */}
                    <S.Name>{name} </S.Name>
                    {/* </div> */}
                    {/* <div style={{border:"1px solid red"}}> */}
                    {badge && (
                      <S.BadgeStyle badgeColor={badgeColor} badgeBg={badgeBg}>
                        {badge}
                      </S.BadgeStyle>
                    )}
                     {legacy && (
                      <S.BadgeStyle badgeColor={badgeColor} badgeBg={"#f0aa117d"}>
                       {legacy}
                      </S.BadgeStyle>
                    )}
                    {/* </div> */}
                    <RenderWhen.If isTrue={!!meta}>
                      <S.Meta className="m-0 p-0">{_getMeta(meta)}</S.Meta>
                    </RenderWhen.If>
                  </>
                )}
              </div>
            )}

            {statusProps && (
              <StatusComp
                {...statusProps}
                status={status}
                iscomment={iscomment}
                showcomment={showcomment}
                setShowComment={setShowComment}
                closecomment={closecomment}
              />
            )}
            <div>
              {text &&
                (text?.length! > MAX_LENGTH ? (
                  <S.ProfileDesc className="m-0 p-0">
                    {`${text?.substring(0, MAX_LENGTH)}...`}
                    <S.CustomIcon>
                      <a href="#">{symbol}</a>
                    </S.CustomIcon>
                  </S.ProfileDesc>
                ) : (
                  <S.DescriptionText className="m-0 p-0">
                    {text} <S.CustomIcon />
                  </S.DescriptionText>
                ))}
            </div>
          </S.SCol>
        </Row>
        {name && <Row className="flex-start mt-3">{_renderList()}</Row>}
        <S.IconContainer>{_renderIcons(groupIcons)}</S.IconContainer>
        {/* </div> */}
        <S.SCol>
          <div className="d-flex ">
            {checkBoxText ? (
              <S.CheckWrap>
                <Form.Group>
                  <Form.Check
                    className="formcheck form-check-select mt-1 mb-1 ps-4"
                    type={'checkbox'}
                    label={checkBoxText}
                    aria-label={`check-1`}
                    value={'check'}
                    style={{ color: color }}
                    onChange={() => {
                      setChecked(!checked);
                      checked ? setColor('red') : setColor('green');
                    }}
                  />
                </Form.Group>
              </S.CheckWrap>
            ) : null}
            {submitBtnText && !!checkBoxText && !checked ? (
              <>
                {/* <OverlayTrigger
                  overlay={(props) => (
                    <Tooltip {...props}>
                      {'kindly check the acknowlegment to submit'}
                    </Tooltip>
                  )}
                  placement={'left'}
                > */}
                <div
                  className={`${
                    checkBoxText ? '' : 'd-flex justify-content-end w-100'
                  }`}
                >
                  <Button
                    onClick={onSubmit}
                    disabled={!!checkBoxText && !checked}
                  >
                    {submitBtnText}
                  </Button>
                </div>
                {/* </OverlayTrigger> */}
              </>
            ) : (
              submitBtnText && (
                <div
                  className={`${
                    checkBoxText ? '' : 'd-flex justify-content-end w-100'
                  }`}
                >
                  <Button
                    onClick={onSubmit}
                    disabled={!!checkBoxText && !checked}
                    className="m-2"
                  >
                    {submitBtnText}
                  </Button>
                  {terminateText && (
                    <Button
                      onClick={onTerminate}
                      disabled={!!checkBoxText && !checked}
                      className="m-2 btn btn-danger"
                    >
                      {terminateText}
                    </Button>
                  )}
                </div>
              )
            )}
            {terminateText && !submitBtnText && (
              <div
                className={`${
                  checkBoxText ? '' : 'd-flex justify-content-end w-100'
                }`}
              >
                <Button
                  onClick={onTerminate}
                  disabled={!!checkBoxText && !checked}
                  className="m-2 btn btn-danger"
                >
                  {terminateText}
                </Button>
              </div>
            )}
            {downloadButtonText && (
              <div>
                <Button
                  onClick={onDownload}
                  disabled={!!checkBoxText && !checked}
                  className="m-2 btn btn-warning"
                >
                  {downloadButtonText}
                </Button>
              </div>
            )}
            {verifyBtnText && (
              // <div>
                <S.VerifyButton
                  onClick={onVerify}
                  disabled={!!checkBoxText && !checked}
                  className="m-2 btn btn-primary"
                  
                >
                  {verifyBtnText}
                </S.VerifyButton>
              // </div>
            )}
          </div>
        </S.SCol>
      </S.SRow>
    </div>
  );
};

ProfileComp.defaultProps = {
  symbol: '>',
  metaSymbol: '•',
};
